// extracted by css-extract-rspack-plugin
export default {"badge":"header-fragment__StepsBar_badge__jzm3A","checkoutSteps":"header-fragment__StepsBar_checkoutSteps__GY59+","fixedTop":"header-fragment__StepsBar_fixedTop__03tbs"};